import React from "react";
import ReactDOM from "react-dom";
import { render } from "react-dom";
import { Provider } from "react-redux";

import { store } from "./_helpers";
import { App } from "./App";
import "./responsive.css";
import withClearCache from "./withClearCache";
import { LanguageProvider, LanguageContext } from "./context/LanguageContext";

// setup fake backend
// import { configureFakeBackend } from "./_helpers";
// configureFakeBackend();

if (typeof window !== "undefined" && window.fetch) {
  window.fetch = window.fetch.bind(window);
}

const session = () => (
  <Provider store={store}>
    <App />
  </Provider>
);

const ClearCacheComponent = withClearCache(App);
ReactDOM.render(
  <LanguageProvider>
    <Provider store={store}>
      <ClearCacheComponent />
    </Provider>
  </LanguageProvider>,
  document.getElementById("root")
);
